import useAppModelChange from "@src/backbone/hooks/useAppModelChange";
import useCartModelChange from "@src/backbone/hooks/useCartModelChange";
import useCustomerModelChange from "@src/backbone/hooks/useCustomerModelChange";
import {
  ECartNow,
  ICartDeliveryOptionsVAD,
} from "@src/backbone/model/CartModel";
import { ICartDeliveryOptionsVAE } from "@src/backbone/model/CartModel";
import CustomerModel from "@src/backbone/model/CustomerModel";
import OrderModel from "@src/backbone/model/OrderModel";
import { CustomerData } from "@src/interface/Customer";
import { useAppSelector } from "@src/store/hooks";
import debounce from "lodash/debounce";
import { useEffect, useRef, useState } from "react";

const useGetLastOrder = () => {
  const [loading, setLoading] = useState(true);
  const [loadingOrder, setLoadingOrder] = useState(true);
  const [updatingDeliveryOptions, setUpdatingDeliveryOptions] = useState(false);
  const orderRef = useRef<OrderModel | null>(null);

  const setupInitialized = useAppSelector(
    (state) => state.app.setupInitialized
  );
  const [, app] = useAppModelChange(["customer"]);
  const [, customer] = useCustomerModelChange(["id_customer"]);
  const [, cart] = useCartModelChange(["deliveryOptions"]);

  useEffect(() => {
    if (setupInitialized && customer.isLogged()) {
      setLoading(true);
      const promise = customer.fetch() as unknown as Promise<CustomerData>;

      customer.on("sync", (cus: CustomerModel) => {
        const idCustomer = cus?.get("id_customer");
        if (idCustomer) {
          const order = cus.getLastOrder();
          if (order) {
            setLoadingOrder(true);
            const orderPromise = order.fetch() as unknown as Promise<any>;
            order.on("sync", (orderModel: OrderModel) => {
              orderRef.current = orderModel;
              // updateOrderData(orderModel);
            });
            orderPromise.finally(() => setLoadingOrder(false));
          } else {
            console.log("navigate home");
            // app.go("home");
          }
        }
      });

      promise
        // .then((data) => {
        //   console.log("data", data);
        // })
        // .catch((error) => {
        //   console.log("warn", error);
        // })
        .finally(() => setLoading(false));
    }
  }, [setupInitialized]);

  const updateDeliveryOptions = debounce(async () => {
    if (orderRef.current && !updatingDeliveryOptions) {
      setUpdatingDeliveryOptions(true);
      const isVAE = orderRef.current.isVAE();

      if (isVAE) {
        cart
          .setDeliveryOptions(
            {
              vae: 1,
              id_store: orderRef.current.getStore()?.get("id_store"),
            },
            {
              autoConfirm: true,
            }
          )
          .then(() => {
            console.log("deliveryOptions");
          })
          .catch((error) => {
            console.error("error", error);
          })
          .finally(() => setUpdatingDeliveryOptions(false));
      } else {
        const orderDeliveryAddress = orderRef.current.getDeliveryAddress();

        const orderDeliveryOptions: ICartDeliveryOptionsVAD = {
          vae: 0,
          now: ECartNow.NOW,
          id_district: orderDeliveryAddress?.get("id_district"),
          id_postcode: orderDeliveryAddress?.get("id_postcode"),
          postcode: orderDeliveryAddress?.get("postal_code"),
          street: orderDeliveryAddress?.get("street"),
          number: orderDeliveryAddress?.get("number"),
          latitude: orderDeliveryAddress?.get("latitude"),
          longitude: orderDeliveryAddress?.get("longitude"),
          autocomplete_literal: orderDeliveryAddress?.get("description"),
          id_address_delivery: orderRef.current.get("id_address_delivery"),
          id_address: orderDeliveryAddress?.get("id_address"),
          id_store: orderRef.current.getStore()?.get("id_store"),
          place_id: orderDeliveryAddress?.get("place_id"),
        };

        try {
          await cart.setDeliveryOptions(orderDeliveryOptions, {
            autoConfirm: true,
          });
        } catch (error) {
          console.error("error", error);
        } finally {
          setUpdatingDeliveryOptions(false);
        }
      }
    }
  }, 500);
  return {
    lastOrder: orderRef.current,
    loading,
    loadingOrder,
    updateDeliveryOptions,
  };
};

export default useGetLastOrder;
